/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import widgetModule, { imagesStyles, swiperOptions } from "@stoneage/App/Widgets/ImageSlider/ImageSlider";
import { styledSlider, xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

swiperOptions.breakpoints = {
    0: {
        slidesPerView: 1.1,
    },
    700: {
        slidesPerView: 1.8,
    },
    900: {
        slidesPerView: 2.1,
    },
    1024: {
        slidesPerView: 2.5,
    },
    1100: {
        slidesPerView: 4,
    },
};

imagesStyles.imagesContainer = {
    css: css`
        ${styledSlider()}
        .swiper-container {
            width: 100% !important;
        }

        .swiper-slide {
            display: flex;
            justify-content: center;
            padding: 0 11px;
            ${xScreen("lte", "xs")} {
                padding: 0px 8px;
            }
        }

        .swiper-pagination {
            display: none;
        }

        .swiper-navigation {
            display: none;
        }

        .justify-content-end {
            justify-content: flex-end;
        }
        .justify-content-start {
            justify-content: flex-start;
        }
    `,
};

export * from "@stoneage/App/Widgets/ImageSlider/ImageSlider";
export default widgetModule;
